/* eslint-disable react-hooks/exhaustive-deps */
import "./style.css";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Grid,
  Button,
  InputAdornment,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import CustomTextField from "../../Components/TextField";
import HelmetReact from "../../Components/Helmet";
import Divider from "@mui/material/Divider";
import LineChart from "../../Components/Chart";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateRangePicker } from "materialui-daterange-picker";
import DeleteForeverSharpIcon from "@mui/icons-material/DeleteForeverSharp";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { saveAs } from "file-saver";
import {
  ReportGraphAction,
  GetCancerTypesAction,
} from "../../Redux/Actions/ReportActions";
export const Report = () => {
  const ITEM_HEIGHT = 48;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
        maxWidth: ITEM_HEIGHT * 7.5,
      },
    },
  };
  const { GraphData, CancerTypes } = useSelector((state) => state.Report);
  const dispatch = useDispatch();
  const [maxValue, setMaxValue] = useState([]);
  const [avgValue, setAvgValue] = useState(0);
  const [DatasetLabel, setDatasetLabel] = useState("");
  const [selectedValue, setSelectedValue] = useState("PROGRAMS");
  const [filterText, setFilterText] = useState("");
  const [chartTitle, setChartTitle] = useState(
    "Program Completion Rate (%)"
  );
  const [dropDownValue, setDropDownValue] = useState();
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [newDate, setNewDate] = useState(dayjs(new Date()));
  const [dateChanged, setDateChanged] = useState(false);
  const [calenderChanged, setCalenderChanged] = useState(false);
  const [open, setOpen] = useState(false);
  const [Dopen, setDOpen] = useState(false);

  const toggle = () => setOpen(!open);

  const [filterValue, setFilterValue] = useState("year");
  const [checkedList, setCheckedList] = useState([]);
  const [chartStatus, setChartStatus] = useState("single");
  const CancerStages = [
    { id: "Stage I", name: "Stage I" },
    { id: "Stage II", name: "Stage II" },
    { id: "Stage III", name: "Stage III" },
    { id: "Stage IV", name: "Stage IV" },
    { id: "Not Sure - Early", name: "Not Sure - Early" },
    { id: "Not Sure - Advanced", name: "Not Sure - Advanced" },
  ];
  const Ethnicity = [
    { id: "White", name: "White" },
    {
      id: "Mixed or multiple ethnic groups",
      name: "Mixed or multiple ethnic groups",
    },
    {
      id: "Asian, Asian Scottish or Asian British",
      name: "Asian, Asian Scottish or Asian British",
    },
    {
      id: "Black, African, Caribbean or Black British",
      name: "Black, African, Caribbean or Black British",
    },
    { id: "Other ethnic group", name: "Other ethnic group" },
  ];
  //get cancer types
  useEffect(() => {
    dispatch(GetCancerTypesAction());
  }, []);
  //filter keywords
  useEffect(() => {
    let TempfilterText = filterText.toUpperCase();
    if (select.includes(TempfilterText) === true) {
      setSelectedValue(TempfilterText);
      setChartTitle(TempfilterText);
    }
    let payload = {
      key: TempfilterText || selectedValue,
      filter_by: filterValue,
    };
    if (!dateChanged && !open && dateRange && filterValue === "custom") {
      payload = {
        ...payload,
        date_range: dateRange,
      };
    } else if (
      filterValue === "filterByDate" &&
      !calenderChanged &&
      !Dopen &&
      newDate
    ) {
      payload = {
        ...payload,
        date_range: {
          startDate: moment(newDate?.$d).format("MM-DD-yyyy"),
          endDate: moment(newDate?.$d).format("MM-DD-yyyy"),
        },
      };
    }
    dispatch(ReportGraphAction(payload));
  }, [filterText]);
  //set data for csv or pdf download
  useEffect(() => {
    let tempArray = [];
    GraphData?.length &&
      GraphData?.map((value) => tempArray.push(Math.ceil(value.value)));
    setMaxValue(tempArray);
  }, [GraphData]);

  useEffect(() => {
    let sum = 0;
    maxValue?.map((item) => (sum = sum + item));
    GraphData && GraphData?.length && setAvgValue(sum / GraphData.length);
  }, [maxValue, GraphData]);

  //call when change the value of filterValue,calenderChanged,dateChanged
  useEffect(() => {
    let payload = {
      key: selectedValue,
      filter_by: filterValue,
    };
    switch (selectedValue) {
      case "ETHNICITY":
        payload = {
          ...payload,
          ethnicity: dropDownValue || "",
        };
        break;
      case "CANCER STAGES":
        payload = {
          ...payload,
          cancer_stage: dropDownValue || "",
        };
        break;
      case "CANCER TYPES":
        payload = {
          ...payload,
          cancer_id: dropDownValue || "",
        };
        break;
      default:
        payload = {
          key: selectedValue,
          filter_by: filterValue,
        };
        break;
    }

    if (chartStatus !== "single") {
      payload = {
        ...payload,
        key: checkedList,
      };
    }

    if (filterValue !== "custom" && filterValue !== "filterByDate") {
      dispatch(ReportGraphAction(payload));
    } else if (filterValue === "custom" && dateChanged && !open) {
      payload = {
        ...payload,
        date_range: dateRange,
      };
      dispatch(ReportGraphAction(payload));
      setDateChanged(false);
    } else if (filterValue === "filterByDate" && calenderChanged && !Dopen) {
      payload = {
        ...payload,
        date_range: {
          startDate: moment(newDate?.$d).format("MM-DD-yyyy"),
          endDate: moment(newDate?.$d).format("MM-DD-yyyy"),
        },
      };
      dispatch(ReportGraphAction(payload));
      setCalenderChanged(false);
    }
  }, [filterValue, selectedValue, dateChanged, calenderChanged]);

  //styles for pdf
  const styles = StyleSheet.create({
    mainPage: {
      padding: "15px",
      fontSize: "12px",
      backgroundColor: "#f9f9f9",
      color: "#1d1d1d",
    },

    scoreMainCard: {
      marginLeft: "30px",
      width: "25vw",
    },
    scoreLabel: {
      margin: "20px 0px auto 0px",
      fontSize: "15px",
    },

    scoreSubLabel1: { margin: "10px 0px 0px 50px", display: "flex" },
    scoreSubLabel2: { margin: "10px 0px 0px 120px", fontWeight: "800" },
    scoreCardSubLabel1: {
      fontSize: "15px",
      marginLeft: "30px",
    },
    scoreCardSubLabel2: {
      textAlign: "center",
      width: "50px",
      backgroundColor: "#1976d2",
      color: "white",
    },
    divider: {
      borderBottom: "1px solid black",
      width: "25vw",
      marginTop: "10px",
    },
    DataContainer: {
      flexDirection: "row",

      justifyContent: "space-between",
      marginTop: "7px",
      width: "25vw",
    },
  });

  const scales = {
    x: {
      ticks: {
        callback: function (tick) {
          var characterLimit = 4;
          if (labels) {
            if (labels?.length && labels?.length > 4) {
              if (labels[tick]?.length >= characterLimit) {
                return (
                  labels[tick]
                    ?.slice(0, labels[tick]?.length)
                    ?.substring(0, characterLimit - 1)
                    ?.trim() + ".."
                );
              }
            }
            return labels[tick];
          }
        },
      },
    },
    y: {
      title: {
        display: true,   
        color: "green",
        font: {
          size: 12,
        },
      },
      position: 'left',
      type: 'linear',
      ticks: { beginAtZero: true, color: '#04c3f6' },
      grid: { display: true }
    },
    y2: {
      title: {
        display: true,
        // text: 'ICECAP',
        color: "red",
        font: {
          size: 12,
        },
      },
      type: 'linear',
      position: 'right',
      ticks: { color: '#9d57e7' },
      grid: { display: false },
    },
  }

  const customScales = useMemo(() => {
    if (selectedValue === "DELTA AVERAGE") {
      return { ...scales };
    } else {
      const { y, y2, ...rest } = scales;
      return { ...rest };
    }
  }, [scales, selectedValue]);

  //options for chart
  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        onClick: null,
      },

      title: {
        display: chartStatus === "single" ? true : "false",
        text: chartStatus === "single" ? chartTitle : "",
        color: "#1976d2",
        align: "center",
        font: {
          height: "10px",
        },
        padding: {
          top: 30,
          bottom: 30,
        },
        fullSize: true,
      },
      interaction: {
        intersect: true,
      },
      tooltip: {
        usePointStyle: false,
      },

      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: "x",
        },
      },
    },
    scales:
      { ...customScales }
  };

  //set labels for chart
  const labels = useMemo(() => {
    if (selectedValue === "DELTA AVERAGE") {
      return GraphData?.length &&
        GraphData?.map((value) =>
          `E-${value.entry}`
        );
    } else {
      return GraphData?.length &&
        GraphData?.map((value) =>
          filterValue === "week" ? moment(value?.month).format("dddd") : value.month
        );
    }
  }, [GraphData, selectedValue, filterValue])

  const data = {
    labels: labels,
    datasets:
      selectedValue === "DELTA AVERAGE" ?
        [
          {
            yAxisID: 'y',
            label: "FACTG",
            data: GraphData?.length &&
              GraphData?.map((value) => Math.ceil(value.factg)),
            fill: true,
            backgroundColor: "rgba(155,230,249,0.5)",
            borderColor: "rgb(155,230,249)",
            pointBackgroundColor: "white",
            pointStyle: "circle",
            borderWidth: 1,
            pointRadius: 5,
            pointHoverRadius: 7,
            tension: 0.4,
          },
          {
            yAxisID: 'y2',
            label: "ICECAP",
            data: GraphData?.length &&
              GraphData?.map((value) => Math.ceil(value.icecap)),
            fill: true,
            backgroundColor: "rgba(198,151,245,0.5)",
            borderColor: "rgb(198, 151, 245)",
            pointBackgroundColor: "white",
            pointStyle: "circle",
            borderWidth: 1,
            pointRadius: 5,
            pointHoverRadius: 7,
            tension: 0.4,
          },
        ]
        :
        selectedValue !== "ACTIVE USERS" && selectedValue !== "GENDER"
          ? [
            {
              label:
                selectedValue === "CANCER TYPES" ||
                  selectedValue === "CANCER STAGES" ||
                  selectedValue === "ETHNICITY"
                  ? DatasetLabel
                  : selectedValue ?? "PROGRAMS",
              data:
                GraphData?.length &&
                GraphData?.map((value) => Math.ceil(value.value)),
              fill: true,
              backgroundColor: "rgba(155,230,249,0.5)",
              borderColor: "rgb(155,230,249)",
              pointBackgroundColor: "white",
              pointStyle: "circle",
              borderWidth: 1,
              pointRadius: 5,
              pointHoverRadius: 7,
              tension: 0.4,
            },
          ]
          : [
            {
              label:
                selectedValue === "ACTIVE USERS"
                  ? "CLIENTS"
                  : selectedValue === "GENDER"
                    ? "MALE"
                    : "",
              data:
                selectedValue === "ACTIVE USERS"
                  ? GraphData?.length &&
                  GraphData?.map((value) => Math.ceil(value.patient))
                  : selectedValue === "GENDER"
                    ? GraphData?.length &&
                    GraphData?.map((value) => Math.ceil(value.male))
                    : [],
              fill: true,
              backgroundColor: "rgba(155,230,249,0.5)",
              borderColor: "rgb(155,230,249)",
              pointBackgroundColor: "white",
              pointStyle: "circle",
              borderWidth: 1,
              pointRadius: 5,
              pointHoverRadius: 7,
              tension: 0.4,
            },
            {
              label:
                selectedValue === "ACTIVE USERS"
                  ? "PRACTIONERS"
                  : selectedValue === "GENDER"
                  ? "FEMALE"
                  : "",

              data:
                selectedValue === "ACTIVE USERS"
                  ? GraphData?.length &&
                    GraphData?.map((value) => Math.ceil(value.doctor))
                  : selectedValue === "GENDER"
                  ? GraphData?.length &&
                    GraphData?.map((value) => Math.ceil(value.female))
                  : [],
              fill: true,
              backgroundColor: "rgba(198,151,245,0.5)",
              borderColor: "rgb(198, 151, 245)",
              pointBackgroundColor: "white",
              pointStyle: "circle",
              borderWidth: 1,
              pointRadius: 5,
              pointHoverRadius: 7,
              tension: 0.4,
            },
          ],
  };

  //set data for chart when needs to display multiple charts
  const data2 = {
    labels: labels,
    datasets: [
      {
        label: checkedList && checkedList[0],
        data:
          GraphData?.length &&
          GraphData?.map((value) => Math.ceil(value.value1)),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
      {
        label: checkedList && checkedList[1],
        data:
          GraphData?.length &&
          GraphData?.map((value) => Math.ceil(value.value2)),
        fill: true,
        backgroundColor: "rgba(198,151,245,0.5)",
        borderColor: "rgb(198, 151, 245)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  //handle Select value on menu changed
  const handleChange = (e, item) => {
    setCheckedList([]);
    setChartStatus("single");
    setFilterText("");
    let payload = {
      key: item,
      filter_by: filterValue,
    };
    let ans;
    setDropDownValue(e.target.value);
    switch (item) {
      case "CANCER TYPES":
        setChartTitle("# CANCER TYPE");
        ans = CancerTypes?.filter((type) => type.id === e.target.value);
        payload = {
          ...payload,
          cancer_id: e.target.value,
        };
        break;
      case "CANCER STAGES":
        setChartTitle("# CANCER STAGE");
        ans = CancerStages?.filter((type) => type.id === e.target.value);
        payload = {
          ...payload,
          cancer_stage: e.target.value,
        };
        break;
      case "ETHNICITY":
        setChartTitle("# ETHNICITY");
        ans = Ethnicity?.filter((type) => type.id === e.target.value);
        payload = {
          ...payload,
          ethnicity: e.target.value,
        };
        break;
      default:
        setChartTitle("");
        setDatasetLabel("DEFAULT");
        break;
    }
    if (DatasetLabel !== "DEFAULT") {
      if (!dateChanged && !open && dateRange && filterValue === "custom") {
        payload = {
          ...payload,
          date_range: dateRange,
        };
      } else if (
        filterValue === "filterByDate" &&
        !calenderChanged &&
        !Dopen &&
        newDate
      ) {
        payload = {
          ...payload,
          date_range: {
            startDate: moment(newDate?.$d).format("MM-DD-yyyy"),
            endDate: moment(newDate?.$d).format("MM-DD-yyyy"),
          },
        };
      }
      setSelectedValue(item);
      setDatasetLabel(ans[0].name);
      dispatch(ReportGraphAction(payload));
    }
  };
  // handle Selected value on button click
  const handleClick = (item) => {
    setCheckedList([]);
    setChartStatus("single");
    setFilterText("");
    item === "PROGRAMS"
      ? setChartTitle(
        "Program Completion Rate (%)"
      )
      : item === "ACTIVE USERS"
        ? setChartTitle(
          "Active Users"
        )
        : item === "SLEEP"
          ? setChartTitle("# SLEEPING HOURS ")
          : item === "ACTIVITY"
            ? setChartTitle("# ACTIVITY SCORE ")
            : item === "HRV"
              ? setChartTitle("# HRV ")
              : item === "FACTG"
                ? setChartTitle("# FACTG  ")
                : item === "ICECAP"
                  ? setChartTitle("# ICECAP  ")
                  : item === "MDASI"
                    ? setChartTitle("# MDASI  ")
                    : item === "CANCER TYPE"
                      ? setChartTitle("# CANCER TYPE")
                      : item === "GENDER"
                        ? setChartTitle("# GENDER")
                        : item === "DELTA AVERAGE"
                          ? setChartTitle("# DELTA AVERAGE")
                          : setChartTitle("");

    setSelectedValue(item);
    let payload = {
      key: item,
      filter_by: filterValue,
    };
    if (!dateChanged && !open && dateRange && filterValue === "custom") {
      payload = {
        ...payload,
        date_range: dateRange,
      };
    } else if (
      filterValue === "filterByDate" &&
      !calenderChanged &&
      !Dopen &&
      newDate
    ) {
      payload = {
        ...payload,
        date_range: {
          startDate: moment(newDate?.$d).format("MM-DD-yyyy"),
          endDate: moment(newDate?.$d).format("MM-DD-yyyy"),
        },
      };
    }
    dispatch(ReportGraphAction(payload));
  };

  //for PDF
  let FC = selectedValue.charAt(0).toUpperCase();
  let RC = selectedValue.slice(1).toLowerCase();

  const handleClear = (e) => {
    setFilterText("");
  };

  //filter value array
  const FilterArray = [
    { key: "day", value: "D" },
    { key: "week", value: "W" },
    { key: "month", value: "M" },
    { key: "year", value: "Y" },
    { key: "custom", value: "CUSTOM" },
  ];
  //keyword array
  const select = [
    "PROGRAMS",
    "SLEEP",
    "ACTIVITY",
    "HRV",
    "FACTG",
    "ICECAP",
    "MDASI",
    "AGE",
    "ACTIVE USERS",
    "GENDER",
    "CANCER TYPES",
    "CANCER STAGES",
    "ETHNICITY",
    "DELTA AVERAGE"
  ];

  //genrate and download pdf
  const generatePDF = async () => {
    const chartCanvas = await document.querySelector("#my-report-chart");
    const chartData = await chartCanvas.toDataURL();

    const blob = await pdf(
      <Document>
        <Page style={styles.mainPage} wrap size="A4" orientation="landscape">
          <View>
            <Image src={chartData} />
            <View style={styles.scoreMainCard}>
              <View style={styles.scoreLabel}>
                <Text style={styles.scoreSubLabel1}>
                  {FC.concat(RC)} Score (Oura)
                </Text>
                <Text style={styles.scoreSubLabel2}>Current</Text>

                <View style={styles.divider} />
              </View>
            </View>
            <View>
              <View style={styles.DataContainer}>
                <Text style={styles.scoreCardSubLabel1}>Avg.</Text>
                <Text style={styles.scoreCardSubLabel2}>
                  {Math.ceil(avgValue)}
                </Text>
              </View>
              <View style={styles.DataContainer}>
                <Text style={styles.scoreCardSubLabel1}>Max.</Text>

                <Text style={styles.scoreCardSubLabel2}>
                  {Math.max(...maxValue)}
                </Text>
              </View>
              <View style={styles.DataContainer}>
                <Text style={styles.scoreCardSubLabel1}>Min.</Text>
                <Text style={styles.scoreCardSubLabel2}>
                  {Math.min(...maxValue)}
                </Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    ).toBlob();
    saveAs(blob, "Report");
  };

  const toggleDatePicker = () => {
    setFilterValue("");
    setDOpen(!Dopen);
  };

  //handle date range
  const handleDateRange = (range) => {
    setDateChanged(true);
    setDateRange({
      startDate: moment(range?.startDate).format("MM-DD-yyyy"),
      endDate: moment(range?.endDate).format("MM-DD-yyyy"),
    });
    setOpen(false);
  };

  //handle date picker
  const handleDate = (newValue) => {
    setFilterValue("filterByDate");
    setCalenderChanged(true);
    setNewDate(newValue);
    setDOpen(false);
  };

  //clear filter values
  const clearFilter = () => {
    setSelectedValue("PROGRAMS");
    setFilterValue("year");
    setFilterText("");
    setCheckedList([]);
    setChartTitle(
      " Program Completion Rate (%)"
    );
  };

  //call for update checklist
  useMemo(() => {
    if (checkedList?.length && checkedList?.length >= 2) {
      setSelectedValue("");
      setFilterText("");
      let payload = {
        key: JSON.stringify(checkedList),
        filter_by: filterValue,
      };

      if (!dateChanged && !open && dateRange && filterValue === "custom") {
        payload = {
          ...payload,
          date_range: dateRange,
        };
      } else if (
        filterValue === "filterByDate" &&
        !calenderChanged &&
        !Dopen &&
        newDate
      ) {
        payload = {
          ...payload,
          date_range: {
            startDate: moment(newDate?.$d).format("MM-DD-yyyy"),
            endDate: moment(newDate?.$d).format("MM-DD-yyyy"),
          },
        };
      }

      dispatch(ReportGraphAction(payload));
      setChartStatus("double");
    }
    if (chartStatus !== "single" && checkedList && checkedList?.length === 0) {
      setSelectedValue("PROGRAMS");
      setFilterValue("year");
      setChartStatus("single");
    }
  }, [checkedList]);
  //handle Checked changed to set the more than 2 keywords(select value)
  const handleChecked = (e) => {
    if (checkedList?.length > 1) {
      checkedList?.shift();
    }
    if (e.target.checked && !checkedList?.includes(e.target.name)) {
      setCheckedList([...checkedList, e.target.name]);
    } else {
      setCheckedList([...checkedList.filter((x) => x !== e.target.name)]);
      setChartTitle(
        " Program Completion Rate (%)"
      );
    }
  };

  return (
    <>
      <HelmetReact name="Report" />

      <Box className="d-details-box">
        <Grid container>
          <Grid item>
            <Button
              variant="contained"
              className="download-report-btn"
              sx={{
                backgroundColor: "#000",
                color: "white",
                borderRadius: "20px",
                width: "200px",
                height: "15",
              }}
              onClick={generatePDF}
            >
              Download Report
            </Button>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item lg={4} md={4} sm={12} xs={12} className="filter-report">
            <CustomTextField
              sx={{ width: "320px" }}
              fieldType="textInput"
              required
              variant="standard"
              className="filter-report"
              value={filterText}
              onChange={(e) => [
                setCheckedList([]),
                setFilterText(e.target.value),
              ]}
              placeholder="Search biomarkers by keyword"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />{" "}
                  </InputAdornment>
                ),

                endAdornment: (
                  <InputAdornment position="end">
                    {filterText ? (
                      <CloseIcon
                        onClick={handleClear}
                        sx={{ cursor: "pointer" }}
                      />
                    ) : (
                      ""
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item lg={4} md={6} sm={12} xs={12} sx={{ display: "flex" }}>
            {FilterArray.map((item, index) => (
              <React.Fragment key={index}>
                <>
                  <Button
                    // variant="standard"
                    sx={{ height: 40, width: 10 }}
                    onClick={() => {
                      if (item.value === "CUSTOM") {
                        setOpen(true);
                      }
                      setFilterValue(item.key);
                    }}
                    variant={
                      filterValue === item.key ? "contained" : "outlined"
                    }
                  >
                    {item.value}
                  </Button>
                </>
              </React.Fragment>
            ))}
          </Grid>

          <Box className="date_popover">
            <DateRangePicker
              open={open}
              toggle={toggle}
              onChange={(range) => handleDateRange(range)}
            />
          </Box>
          <Grid item lg={4} md={6} sm={12} xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <>
                <Button
                  onClick={toggleDatePicker}
                  endIcon={<CalendarMonthIcon />}
                  variant="contained"
                  className="custom_popover"
                  sx={{ height: 40 }}
                >
                  Filter by Date
                </Button>

                {Dopen && (
                  <DateCalendar
                    value={newDate}
                    onChange={(newValue) => handleDate(newValue)}
                  />
                )}
              </>
            </LocalizationProvider>
            <Button
              onClick={clearFilter}
              variant="contained"
              // sx={{ height: 40, borderRadius: "50%", mx: 2 }}
              sx={{ height: 40, borderRadius: 5, mx: 2 }}
            >
              <DeleteForeverSharpIcon />
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Box className="report-select">
              {select.map((item, index) => (
                <React.Fragment key={index}>
                  <>
                    <Box>
                      {item === "CANCER TYPES" ||
                        item === "CANCER STAGES" ||
                        item === "ETHNICITY" ? (
                        <Select
                          MenuProps={MenuProps}
                          defaultValue={item}
                          variant="standard"
                          sx={{
                            width: 330,
                            height: 50,
                            fontFamily: "Poppins,Raleway,Arial",
                            fontWeight: "500",
                            fontSize: "0.875rem",
                          }}
                          disableUnderline
                          onChange={(e) => {
                            handleChange(e, item);
                          }}
                        >
                          <MenuItem value={item} disabled>
                            {item}
                          </MenuItem>
                          {item === "CANCER TYPES"
                            ? CancerTypes?.map((type) => (
                              <MenuItem key={type.id} value={type?.id}>
                                {type?.name}
                              </MenuItem>
                            ))
                            : item === "CANCER STAGES"
                              ? CancerStages?.map((type) => (
                                <MenuItem key={type.id} value={type?.name}>
                                  {type?.name}
                                </MenuItem>
                              ))
                              : Ethnicity?.map((type) => (
                                <MenuItem key={type.id} value={type?.name}>
                                  {type?.name}
                                </MenuItem>
                              ))}
                        </Select>
                      ) : (
                        <>
                          <Box sx={{ display: "flex" }}>
                            {item !== "ACTIVE USERS" && item !== "GENDER" && item !== "DELTA AVERAGE" && (
                              <Checkbox
                                key={index}
                                name={item}
                                onChange={handleChecked}
                                checked={checkedList?.includes(item)}
                              />
                            )}
                            <Button
                              variant={
                                item === selectedValue
                                  ? "contained"
                                  : "standard"
                              }
                              sx={{
                                width: 330,
                                height: 50,
                              }}
                              onClick={() => {
                                handleClick(item);
                              }}
                            >
                              {item}
                            </Button>
                          </Box>
                        </>
                      )}

                      <Divider />
                    </Box>
                  </>
                </React.Fragment>
              ))}
            </Box>
          </Grid>

          <Grid item lg={8} md={4} sm={12} xs={12}>
            <Box className="report-select-box">
              <LineChart
                type={
                  filterValue === "day" || filterValue === "filterByDate"
                    ? "bar"
                    : "line"
                }
                id="my-report-chart"
                data={chartStatus === "single" ? data : data2}
                options={options}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
